export const WORDS = [
  'etīde',
  'ķerra',
  'birka',
  'satīt',
  'mūris',
  'tvans',
  'hlors',
  'kūdīt',
  'vāģis',
  'serde',
  'posts',
  'šķira',
  'sidrs',
  'kurss',
  'citēt',
  'iziet',
  'bieds',
  'tilts',
  'olīva',
  'birzs',
  'zibēt',
  'kvēpt',
  'vārds',
  'lieta',
  'stāžs',
  'poēma',
  'klēts',
  'šķīst',
  'krāns',
  'ošņāt',
  'čāpot',
  'pulēt',
  'ķēdēt',
  'stars',
  'grozs',
  'rūsēt',
  'kvīts',
  'ronis',
  'žults',
  'rings',
  'zāles',
  'koris',
  'kvēpi',
  'barot',
  'amats',
  'rinda',
  'bumba',
  'pauze',
  'dvaša',
  'laiks',
  'druva',
  'ticēt',
  'tumba',
  'zonde',
  'rudzi',
  'varde',
  'darīt',
  'džezs',
  'lodēt',
  'malks',
  'ķidāt',
  'džins',
  'ņerga',
  'uzacs',
  'tirpt',
  'astma',
  'tulks',
  'čalot',
  'peļņa',
  'pampt',
  'frēze',
  'štats',
  'arkls',
  'barža',
  'krogs',
  'sāpes',
  'pūles',
  'mokas',
  'grūst',
  'torte',
  'zvērs',
  'krūka',
  'kasīt',
  'asums',
  'kēkss',
  'žurka',
  'lapsa',
  'vērpt',
  'vītne',
  'dūdot',
  'vētra',
  'zvans',
  'spāre',
  'halva',
  'vīlēt',
  'zīdīt',
  'galms',
  'druka',
  'klade',
  'mirkt',
  'kvota',
  'rīdīt',
  'kavēt',
  'ābele',
  'filcs',
  'mālēt',
  'ziede',
  'grīda',
  'masts',
  'krāsa',
  'rasot',
  'titrs',
  'prove',
  'lozēt',
  'sekta',
  'pirkt',
  'ozons',
  'miers',
  'plīst',
  'bruka',
  'gurns',
  'šokēt',
  'žagas',
  'nagla',
  'čiept',
  'plēve',
  'burka',
  'tārps',
  'tecēt',
  'lācis',
  'daile',
  'peļķe',
  'putot',
  'scēna',
  'šļūkt',
  'stāds',
  'pļaut',
  'kaste',
  'zelts',
  'nieze',
  'rīkle',
  'brukt',
  'klubs',
  'knābt',
  'sēņot',
  'aukle',
  'ķilda',
  'stiga',
  'balle',
  'laist',
  'alnis',
  'mēris',
  'trūce',
  'tiesa',
  'kalts',
  'cirst',
  'znots',
  'laiva',
  'reņģe',
  'kuģot',
  'svīre',
  'bučot',
  'putns',
  'bekot',
  'čučēt',
  'tērēt',
  'fonds',
  'kūdra',
  'aijāt',
  'mīļot',
  'prese',
  'skābe',
  'purns',
  'pāris',
  'drava',
  'magma',
  'lūrēt',
  'ledus',
  'tūska',
  'ezers',
  'vēsts',
  'putra',
  'rotēt',
  'stāja',
  'auzas',
  'stīpa',
  'saime',
  'izirt',
  'gaume',
  'paēst',
  'dzīve',
  'jauda',
  'bīdīt',
  'birzt',
  'ozols',
  'ideja',
  'nimfa',
  'flote',
  'marss',
  'maska',
  'hidra',
  'kālis',
  'lasis',
  'bulta',
  'sērot',
  'vista',
  'štābs',
  'būvēt',
  'salīt',
  'grāds',
  'grēks',
  'vaids',
  'dusēt',
  'ziņot',
  'šķelt',
  'skābt',
  'cimds',
  'steks',
  'krusa',
  'tosts',
  'zutis',
  'sirgt',
  'meiča',
  'rosme',
  'elsot',
  'bilde',
  'tilde',
  'atzīt',
  'teikt',
  'kanna',
  'forts',
  'vajāt',
  'stūre',
  'gripa',
  'plūme',
  'aijas',
  'drēbe',
  'grims',
  'sijāt',
  'pulss',
  'domāt',
  'korts',
  'krams',
  'bēres',
  'apart',
  'gaita',
  'vieta',
  'plūst',
  'džems',
  'seifs',
  'dozēt',
  'tvīkt',
  'upene',
  'mītne',
  'zampa',
  'kārts',
  'ūbele',
  'ferma',
  'recēt',
  'ciska',
  'grifs',
  'skate',
  'neons',
  'tupēt',
  'tonēt',
  'rombs',
  'skuja',
  'bēdāt',
  'cinks',
  'manna',
  'ķemme',
  'stepe',
  'iegūt',
  'polka',
  'urāns',
  'šahta',
  'knīpa',
  'dzimt',
  'ceļot',
  'urķis',
  'saukt',
  'izdot',
  'ādere',
  'apašs',
  'haoss',
  'pērle',
  'brusa',
  'klupt',
  'zirgs',
  'dīķis',
  'dārds',
  'rūdīt',
  'āmurs',
  'skaņa',
  'cista',
  'aurot',
  'veste',
  'krākt',
  'truba',
  'turza',
  'karot',
  'sārms',
  'gaist',
  'ģilde',
  'cikls',
  'sūbēt',
  'blīve',
  'aloja',
  'slīkt',
  'ritēt',
  'volts',
  'mērkt',
  'tīnis',
  'ražot',
  'cauna',
  'perēt',
  'pekle',
  'spora',
  'ģērbt',
  'cērme',
  'salna',
  'morgs',
  'tenka',
  'žāvēt',
  'rāmis',
  'nulle',
  'burāt',
  'balva',
  'pīpēt',
  'zīmēt',
  'ietve',
  'spura',
  'reize',
  'jumts',
  'mūrēt',
  'palma',
  'rāpot',
  'labot',
  'torss',
  'karte',
  'dejot',
  'vadīt',
  'līkne',
  'bokss',
  'lakta',
  'stabs',
  'kults',
  'blefs',
  'nebūt',
  'pumpa',
  'manīt',
  'ilgas',
  'šņore',
  'krūms',
  'stils',
  'dzeja',
  'svilt',
  'menca',
  'manta',
  'bažas',
  'žanrs',
  'jurģi',
  'rīvēt',
  'miegs',
  'čūska',
  'attīt',
  'dārzs',
  'nātre',
  'zilbe',
  'burts',
  'vinča',
  'gatve',
  'marle',
  'ģints',
  'siens',
  'irsis',
  'urķēt',
  'velve',
  'uzart',
  'pakot',
  'liepa',
  'spars',
  'šarms',
  'prece',
  'šalle',
  'flīze',
  'čells',
  'talka',
  'rūķis',
  'risks',
  'rotāt',
  'jahta',
  'prast',
  'raugs',
  'belzt',
  'hroms',
  'āpsis',
  'kņada',
  'līmēt',
  'palot',
  'golfs',
  'sārts',
  'cilme',
  'dvest',
  'rangs',
  'sarma',
  'sekas',
  'bērns',
  'aliņš',
  'krīts',
  'spole',
  'dzēst',
  'liesa',
  'līnis',
  'minēt',
  'svīst',
  'litrs',
  'pasta',
  'kārot',
  'kauja',
  'mānīt',
  'halle',
  'borts',
  'solīt',
  'klīst',
  'indēt',
  'shēma',
  'telts',
  'daina',
  'velns',
  'lente',
  'smakt',
  'ķēpāt',
  'līcis',
  'runāt',
  'zārks',
  'vēzis',
  'lakot',
  'murds',
  'šķēle',
  'piere',
  'piens',
  'samts',
  'etaps',
  'jards',
  'sāpēt',
  'sēnes',
  'krist',
  'stara',
  'kroka',
  'summa',
  'tents',
  'siets',
  'afiša',
  'anīss',
  'cirpt',
  'hercs',
  'lifts',
  'dzega',
  'uzšūt',
  'mērce',
  'sēkla',
  'krāpt',
  'balss',
  'josta',
  'dzist',
  'gamma',
  'bilst',
  'sairt',
  'jumis',
  'sleja',
  'darbs',
  'lobēt',
  'birža',
  'cālis',
  'galva',
  'kaukt',
  'sīlis',
  'mācīt',
  'elpot',
  'skola',
  'tumsa',
  'būtne',
  'iesēt',
  'prāts',
  'melis',
  'duets',
  'spice',
  'tušēt',
  'padot',
  'sauja',
  'ostīt',
  'bārda',
  'dubļi',
  'kūkot',
  'siena',
  'valis',
  'parks',
  'pīķis',
  'spals',
  'ravēt',
  'grebt',
  'ripot',
  'dzira',
  'sargs',
  'ķidas',
  'skāde',
  'ritms',
  'grāfs',
  'vilks',
  'žilbt',
  'marka',
  'mērīt',
  'krūze',
  'bakas',
  'pļāpa',
  'izēst',
  'sauna',
  'miesa',
  'žāvas',
  'vagot',
  'glābt',
  'uzpīt',
  'kauls',
  'valde',
  'ētika',
  'piķis',
  'kvēle',
  'pakts',
  'dzīle',
  'apsēt',
  'lēkme',
  'lobīt',
  'grodi',
  'tīkot',
  'urdēt',
  'smēre',
  'kalns',
  'maksa',
  'maršs',
  'apirt',
  'brist',
  'plovs',
  'nervs',
  'maijs',
  'grope',
  'panna',
  'piepe',
  'muļļa',
  'asaka',
  'trase',
  'zāģis',
  'svīta',
  'kopēt',
  'zākāt',
  'celis',
  'lampa',
  'dzert',
  'bebrs',
  'dūnas',
  'sfēra',
  'blūze',
  'airis',
  'meita',
  'kraut',
  'anods',
  'drāma',
  'sirds',
  'banka',
  'milti',
  'plīts',
  'čības',
  'potēt',
  'kanva',
  'medus',
  'grimt',
  'kakts',
  'murgi',
  'ciete',
  'pļava',
  'plūkt',
  'trupa',
  'mocīt',
  'jokot',
  'sūtīt',
  'laime',
  'pilēt',
  'klija',
  'takts',
  'dēlis',
  'lauva',
  'skumt',
  'fasēt',
  'šķēps',
  'josla',
  'slava',
  'kāzas',
  'celms',
  'zieds',
  'putas',
  'diena',
  'nomāt',
  'aplis',
  'derma',
  'skats',
  'āksts',
  'muiža',
  'spert',
  'bojāt',
  'arods',
  'turēt',
  'svira',
  'nēģis',
  'kotēt',
  'pelēt',
  'datne',
  'plāns',
  'pelni',
  'uzdot',
  'mizot',
  'vēlēt',
  'tīkls',
  'tanks',
  'kļava',
  'aknas',
  'tulpe',
  'runga',
  'vazāt',
  'tumst',
  'ziest',
  'čubas',
  'sepse',
  'tauki',
  'ieeja',
  'sakne',
  'griba',
  'virve',
  'gāzēt',
  'kalla',
  'masēt',
  'tauta',
  'šķilt',
  'store',
  'izžūt',
  'lenkt',
  'spīts',
  'šifrs',
  'azote',
  'krūts',
  'krāms',
  'ūdens',
  'jaust',
  'lazda',
  'ovāls',
  'bērzs',
  'šļaka',
  'sapūt',
  'vecis',
  'berzt',
  'saite',
  'rasēt',
  'norma',
  'salmi',
  'sieva',
  'dakts',
  'ķeska',
  'siļķe',
  'izšūt',
  'serve',
  'broša',
  'ābols',
  'kalps',
  'glūda',
  'derēt',
  'vārna',
  'krahs',
  'lolot',
  'cilpa',
  'diēta',
  'pults',
  'ķīlāt',
  'alkas',
  'smīns',
  'zobot',
  'sašūt',
  'ārsts',
  'opera',
  'locīt',
  'tonna',
  'tvert',
  'spoks',
  'ieiet',
  'virst',
  'sekot',
  'lamāt',
  'dūzis',
  'rīkot',
  'blusa',
  'dunka',
  'laipa',
  'zveja',
  'apēst',
  'henna',
  'virca',
  'siers',
  'nasta',
  'kaite',
  'vēsma',
  'sesks',
  'tests',
  'triks',
  'pluss',
  'joņot',
  'bedre',
  'delna',
  'tvīts',
  'rūpes',
  'maiss',
  'bloks',
  'mulča',
  'būris',
  'brīze',
  'arums',
  'žēlot',
  'smelt',
  'stops',
  'ateja',
  'dzija',
  'avīze',
  'sēdēt',
  'adata',
  'banda',
  'graut',
  'rieva',
  'tante',
  'sēras',
  'plēst',
  'prāva',
  'lēcas',
  'spēle',
  'vraks',
  'kļūme',
  'gaiss',
  'ārija',
  'posms',
  'stumt',
  'lauzt',
  'migla',
  'krēms',
  'drupt',
  'trose',
  'pamāt',
  'mēdīt',
  'psihe',
  'kūlis',
  'karpa',
  'teika',
  'vizēt',
  'efeja',
  'bauda',
  'deķis',
  'zāģēt',
  'darva',
  'kārta',
  'bļoda',
  'plūdi',
  'eseja',
  'lelle',
  'stīga',
  'ziema',
  'dotēt',
  'oboja',
  'glūņa',
  'vells',
  'zaķis',
  'svins',
  'nieks',
  'auļot',
  'apgūt',
  'veikt',
  'olīve',
  'horda',
  'telpa',
  'vērot',
  'vilkt',
  'villa',
  'velte',
  'marts',
  'atdot',
  'dakša',
  'jaukt',
  'cerēt',
  'klājs',
  'likme',
  'vilna',
  'brūte',
  'kaķis',
  'tāmēt',
  'svērt',
  'slogs',
  'sarkt',
  'nožūt',
  'groži',
  'kaija',
  'gruži',
  'solis',
  'šķūre',
  'šķist',
  'bukse',
  'pirts',
  'sērga',
  'zārds',
  'cilts',
  'pazīt',
  'disks',
  'pūķis',
  'godāt',
  'vasks',
  'pozēt',
  'berze',
  'filma',
  'čaula',
  'ābece',
  'vērst',
  'limfa',
  'dalīt',
  'reibt',
  'omārs',
  'rādīt',
  'īriss',
  'reids',
  'nūjot',
  'mamma',
  'plecs',
  'ēšana',
  'izlīt',
  'panēt',
  'hurma',
  'kokle',
  'viela',
  'brēka',
  'lauki',
  'šņākt',
  'vanna',
  'neļķe',
  'drāts',
  'garša',
  'spēks',
  'līste',
  'melot',
  'snigt',
  'dvīņi',
  'kauns',
  'dūņas',
  'liāna',
  'žests',
  'iesms',
  'ducis',
  'proza',
  'ūdele',
  'griķi',
  'kapāt',
  'slāpt',
  'eposs',
  'klase',
  'metrs',
  'skals',
  'tinte',
  'purvs',
  'nodot',
  'kungs',
  'kross',
  'zināt',
  'rampa',
  'ciems',
  'mācēt',
  'kadrs',
  'grafs',
  'sacīt',
  'algot',
  'kolba',
  'bende',
  'dēvēt',
  'redze',
  'zebra',
  'beigt',
  'ģīmis',
  'apavi',
  'mērot',
  'līgot',
  'ausma',
  'baļļa',
  'ņirgt',
  'urbis',
  'audze',
  'varēt',
  'nauda',
  'stāvs',
  'lāsts',
  'rumba',
  'taure',
  'pulks',
  'trūkt',
  'vārpa',
  'arēna',
  'kedas',
  'zīlēt',
  'zeķes',
  'tonis',
  'skice',
  'kāmis',
  'senči',
  'radze',
  'broms',
  'šorti',
  'līķis',
  'pleds',
  'lidot',
  'ķīlis',
  'krava',
  'kļūda',
  'dievs',
  'taiga',
  'sveķi',
  'svece',
  'pūdēt',
  'pants',
  'kakls',
  'smaka',
  'slota',
  'grams',
  'botes',
  'spēja',
  'kasta',
  'sodīt',
  'cieņa',
  'aktis',
  'konts',
  'grābt',
  'drāna',
  'frāze',
  'gulēt',
  'gulta',
  'vēlme',
  'epika',
  'daiva',
  'sakta',
  'tauva',
  'sirot',
  'tēlot',
  'hiēna',
  'ūziņa',
  'cirks',
  'izeja',
  'kārpa',
  'grava',
  'maiņa',
  'kuģis',
  'riepa',
  'mulst',
  'lūsis',
  'pūlis',
  'radīt',
  'tētis',
  'biete',
  'odere',
  'galds',
  'avots',
  'katls',
  'grēda',
  'medīt',
  'muita',
  'grupa',
  'sarāt',
  'vaina',
  'plate',
  'glāze',
  'mīlēt',
  'slēpt',
  'puika',
  'aukla',
  'avene',
  'norīt',
  'nakts',
  'soļot',
  'elsas',
  'kvass',
  'klons',
  'tērpt',
  'nafta',
  'himna',
  'miets',
  'vaigs',
  'kārba',
  'vidus',
  'skala',
  'pētīt',
  'brēkt',
  'lauks',
  'aleja',
  'naids',
  'bēdas',
  'kalte',
  'kauss',
  'ganīt',
  'īlens',
  'ciest',
  'slēgt',
  'vārti',
  'brūce',
  'paust',
  'saule',
  'diegs',
  'skava',
  'veids',
  'maize',
  'amēba',
  'jezga',
  'uzaut',
  'mīkla',
  'maldi',
  'ārdīt',
  'iedot',
  'krāce',
  'kūpēt',
  'malka',
  'temps',
  'dzelt',
  'lāpīt',
  'vārīt',
  'delms',
  'atoms',
  'nazis',
  'šļākt',
  'izdēt',
  'atgūt',
  'dēsts',
  'tīrīt',
  'niķis',
  'colla',
  'svars',
  'rutks',
  'ēters',
  'tēmēt',
  'bļaut',
  'tērps',
  'lence',
  'ēvele',
  'diēzs',
  'bālēt',
  'svari',
  'šķirt',
  'jūtas',
  'reiss',
  'lasīt',
  'forma',
]
